import type { StoryBlock } from '@/types/content';

interface ArticleBodyProps {
  blocks: StoryBlock[];
  headingIds: string[];
}

export default function ArticleBody({ blocks, headingIds }: ArticleBodyProps) {
  let headingIndex = -1;

  return (
    <div className="prose-gossip mt-8 text-base text-foreground-700">
      {blocks.map((block, i) => {
        if (block.type === 'h3') {
          headingIndex += 1;
          const id = headingIds[headingIndex];
          return (
            <h2
              key={i}
              id={id}
              className="scroll-mt-24 font-heading text-xl font-bold text-foreground-950 md:text-2xl"
            >
              {block.text}
            </h2>
          );
        }
        if (block.type === 'quote') {
          return (
            <blockquote
              key={i}
              className="my-6 rounded-lg border-l-4 border-primary-400 bg-primary-50 px-5 py-4 font-heading text-base italic leading-relaxed text-primary-900"
            >
              {block.text}
            </blockquote>
          );
        }
        return <p key={i}>{block.text}</p>;
      })}
    </div>
  );
}